import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./Components/utils/scrollToTop"
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './App.css'
import Login from "./Pages/Login/login";
import Warehouse from "./Pages/Warehouse/Warehouse";
import Vendors from "./Pages/Vendors/Vendors"
import VendorDetails from "./Pages/Vendors/VendorDetails/vendordetails"
import OmniMartCategories from "./Pages/Category/Omnimart/Category"
import Servicecategories from './Pages/Category/service/Category'
import Subcategories from "./Pages/Subcategory/subCategory"
import Services from "./Pages/service/Services"
import Products from "./Pages/Products/Products"
import ServiceBanners from "./Pages/Banners/Service/Services"
import OmnimartBanners from "./Pages/Banners/Omnimart/Services"
import Coupons from "./Pages/Coupons/coupons"
import Orders from "./Pages/orders/ServiceOrders/Orders"
import GroceryOrders from "./Pages/orders/GroceryOrders/Orders"
import OrderDetails from "./Pages/orders/GroceryOrders/OrderDetails"
import ServiceOrderDetails from './Pages/orders/ServiceOrders/OrderDetails'
import Cities from "./Pages/Cities/cities"
import States from './Pages/States/States'
import Pincode from './Pages/pincodes/pincode'
import Shop from "./Pages/shop/shop"
import User from "./Pages/user/user"
import AdminRoles from "./Pages/roles/roles"
import Accessdenied from "./Pages/AccessDenied/denied"
import Notfound from "./Pages/pageNotfound/pagenotfound"
import Suggestions from './Pages/suggestions/suggestions'
import AdminUsers from "./Pages/AdminUsers/adminusers"
import WarehouseProducts from "./Pages/warehouseproducts/products"
import PurchaseOrder from "./Pages/purchaseOrder/purchaseOrder"
import Suppliers from "./Pages/Suppliers/Supplier"
import AddPurchaseOrder from "./Pages/purchaseOrder/addpurchaseOrder"
import Ledger from "./Pages/ledger/ledger"
import Societies from "./Pages/Societies/Societies"
import Support from "./Pages/CustomerSupport/support"
import Slots from './Pages/slots/slots'
import AddSlots from './Pages/slots/addslots'
import CityServices from './Pages/service(city)/Services'
import Dashboard from './Pages/Dashboard/Dashboard'
import Reports from './Pages/Reports/reports'
import DeliveryTypes from './Pages/DeliveryTypes/DeliveryType'
import GST from './Pages/GST/Gst'
import MobilityUsers from './Pages/MobilityServices/user/user'
import MobilityBookings from './Pages/MobilityServices/Bookings/Orders'
import MobilityBookingDetails from './Pages/MobilityServices/Bookings/OrderDetails'
import MobilityDrivers from './Pages/MobilityServices/Drivers/Drivers'
import DriverDetails from './Pages/MobilityServices/Drivers/Details'
import MobilityBanners from './Pages/MobilityServices/Banners/ServiceBanners'
import WithDrawRequests from './Pages/MobilityServices/withdrawRequests/requests'
import TransportServices from './Pages/MobilityServices/TransportServices/requests'
import MobilityCoupons from './Pages/MobilityServices/Coupons/coupons'
import MobilityConfig from './Pages/MobilityServices/Config/Config'
import MobilityCities from './Pages/MobilityServices/Cities/Cities'
import GuideSupport from './Pages/guideSupport/support'
import UserDetails from './Pages/MobilityServices/user/details'
import Notfications from './Pages/notifications/Notifications'
function App() {
    return (
        <>
            <ToastContainer />

            <ScrollToTop>
                <Routes>
                    <Route exaact path="/" element={<Login />} />
                    <Route exact path="/Warehouse" element={<Warehouse />} />
                    <Route exact path="/notifications" element={<Notfications />} />
                    <Route exact path="/mobility-services/config" element={<MobilityConfig />} />
                    <Route exact path="/mobility-services/cities" element={<MobilityCities />} />
                    <Route exact path="/guide-support" element={<GuideSupport />} />
                    <Route exact path="/mobility-services/Transport_services" element={<TransportServices />} />
                    <Route exact path="/mobility-services/coupons" element={<MobilityCoupons />} />
                    <Route exact path="/mobility-services/Withdraw_requests" element={<WithDrawRequests />} />
                    <Route exact path="/mobility-services/banners" element={<MobilityBanners />} />
                    <Route exact path="/mobility-services/drivers" element={<MobilityDrivers />} />
                    <Route exact path="/mobility-services/driver-details/:id" element={<DriverDetails />} />
                    <Route exact path="/mobility-services/user-details/:id" element={<UserDetails />} />
                    <Route exact path="/mobility-service/users" element={<MobilityUsers />} />
                    <Route exact path="/mobility-services/bookings" element={<MobilityBookings />} />
                    <Route exact path="/booking-Order-details/:id/:type" element={<MobilityBookingDetails />} />
                    <Route exact path="/dashboard" element={<Dashboard />} />
                    <Route exact path="/Vendors" element={<Vendors />} />
                    <Route exact path="/vendor/details" element={<VendorDetails />} />
                    <Route exact path="/omnimart-categories" element={<OmniMartCategories />} />
                    <Route exact path="/Delivery-types" element={<DeliveryTypes />} />
                    <Route exact path="/service-categories" element={<Servicecategories />} />
                    <Route exact path="/subcategories" element={<Subcategories />} />
                    <Route exact path="/Services" element={<Services />} />
                    <Route exact path="/Reports" element={<Reports />} />
                    <Route exact path="/Products" element={<Products />} />
                    <Route exact path="/service-banners" element={<ServiceBanners />} />
                    <Route exact path="/omnimart-banners" element={<OmnimartBanners />} />
                    <Route exact path="/Coupons" element={<Coupons />} />
                    <Route exact path="/service-orders" element={<Orders />} />
                    <Route exact path="/grocery-orders" element={<GroceryOrders />} />
                    <Route exact path="/Order-details" element={<OrderDetails />} />
                    <Route exact path="/Service-Order-details" element={<ServiceOrderDetails />} />
                    <Route exact path="/Cities" element={<Cities />} />
                    <Route exact path="/States" element={<States />} />
                    <Route exact path="/Pincodes" element={<Pincode />} />
                    <Route exact path="/shop" element={<Shop />} />
                    <Route exact path="/user" element={<User />} />
                    <Route exact path="/roles" element={<AdminRoles />} />
                    <Route exact path="/suggestions" element={<Suggestions />} />
                    <Route exact path="/unauthorized" element={<Accessdenied />} />
                    <Route exact path="/adminusers" element={<AdminUsers />} />
                    <Route exact path="/warehouse-Products" element={<WarehouseProducts />} />
                    <Route exact path="/purchaseorder" element={<PurchaseOrder />} />
                    <Route exact path="/AddpurchaseOrder" element={<AddPurchaseOrder />} />
                    <Route exact path="/purchaseOrderDetails/:id" element={<AddPurchaseOrder />} />
                    <Route exact path="/Suppliers" element={<Suppliers />} />
                    <Route exact path="/ledger/:prodid/:warehouseid" element={<Ledger />} />
                    <Route exact path="/societies" element={<Societies />} />
                    <Route exact path="/customer-support" element={<Support />} />
                    <Route exact path="/slots" element={<Slots />} />
                    <Route exact path="/add-slots" element={<AddSlots />} />
                    <Route exact path="/Services/City" element={<CityServices />} />
                    <Route exact path="/GST" element={<GST />} />

                    <Route exact path="*" element={<Notfound />} />


                </Routes>
            </ScrollToTop>
        </>
    );
}

export default App;
